export const WEEK = [
  { key: "mon", label: "Lunedì", open: "06:30", close: "00:00" },
  { key: "tue", label: "Martedì", closed: true },
  { key: "wed", label: "Mercoledì", open: "06:30", close: "00:00" },
  { key: "thu", label: "Giovedì", open: "06:30", close: "00:00" },
  { key: "fri", label: "Venerdì", open: "06:30", close: "00:00" },
  { key: "sat", label: "Sabato", open: "06:30", close: "00:00" },
  { key: "sun", label: "Domenica e festivi", open: "07:30", close: "00:00" },
];

const JS_TO_INDEX = { 1: 0, 2: 1, 3: 2, 4: 3, 5: 4, 6: 5, 0: 6 };

const toMinutes = (s) => {
  const [h, m] = s.split(":").map(Number);
  return h * 60 + m;
};

export function getStatus(now = new Date()) {
  const rome = new Date(now.toLocaleString("en-US", { timeZone: "Europe/Rome" }));
  const idx = JS_TO_INDEX[rome.getDay()];
  const minutes = rome.getHours() * 60 + rome.getMinutes();

  for (let i = 0; i < 8; i++) {
    const ni = (idx + i) % 7;
    const day = WEEK[ni];
    if (day.closed) continue;
    const open = toMinutes(day.open);
    if (i === 0) {
      if (minutes >= open) {
        return { open: true, idx, text: "Aperto ora · fino a mezzanotte" };
      }
      return { open: false, idx, text: `Chiuso · apre alle ${day.open}` };
    }
    const when = i === 1 ? "domani" : day.label.replace(" e festivi", "").toLowerCase();
    return { open: false, idx, text: `Chiuso · riapere ${when} alle ${day.open}`.replace("riapere", "riapre") };
  }
  return { open: false, idx, text: "Chiuso" };
}

export function scrollToHash(hash) {
  const el = document.querySelector(hash);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
}
